<script>
import HiddenTabGroup from "@/components/modals/options/hidden-tabs/HiddenTabGroup";
import ModalWrapperOptions from "@/components/modals/options/ModalWrapperOptions";
import PrimaryButton from "@/components/PrimaryButton";

export default {
  name: "HiddenTabsModal",
  components: {
    HiddenTabGroup,
    ModalWrapperOptions,
    PrimaryButton,
  },
  data() {
    return {
      isEnslaved: false,
      isAlmostEnd: false,
    };
  },
  computed: {
    tabs: () => Tabs.currentUIFormat,
  },
  methods: {
    update() {
      this.isEnslaved = Enslaved.isRunning;
      this.isAlmostEnd = Pelle.hasGalaxyGenerator;
    },
    showAllTabs() {
      for (const tab of this.tabs) {
        tab.unhideTab();
        for (const subtab of tab.subtabs)
          subtab.unhideTab();
      }
    }
  },
};
</script>

<template>
  <ModalWrapperOptions class="l-wrapper">
    <template #header>
      Изменить Видимые Вкладки
    </template>
    <div class="c-modal--short">
      Нажмите на кнопку чтобы скрыть/показать вкладку.
      <br>
      Некоторые вкладки не могут быть скрыты, и вы также не можете спрятать текущую вкладку.
      <br>
      Показывание вкладки, в которой все подвкладки скрыты, покажет все подвкладки.
      Скрытие всех подвкладок спрячет вкладку.
      <br>
      <div v-if="isAlmostEnd">
        Вы не можете скрывать ваши вкладки после разблокировки Генератора Галактик.
      </div>
      <div v-if="isEnslaved">
        <br>
        <i>Ты должен... искать везде...</i>
        <br>
        (Вы не можете скрывать вкладки внутри этой Реальности)
      </div>
      <PrimaryButton
        @click="showAllTabs"
      >
        Показать все вкладки
      </PrimaryButton>
      <HiddenTabGroup
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :change-enabled="!isEnslaved && !isAlmostEnd"
        class="l-hide-modal-tab-container"
      />
    </div>
  </ModalWrapperOptions>
</template>

<style scoped>
.l-wrapper {
  width: 62rem;
}

.t-s12 .l-wrapper {
  width: 65rem;
}
</style>